import {
  PLATFORM_LOGO_BY_TYPE,
  type SOURCE_PLATFORM_TYPE,
} from '@/entities/public-filter/public-filter-constants';
import { AnimatedSuspense } from '@/shared/components/animated-suspense';
import { cn } from '@/shared/utils/cn';
import { formatNumber } from '@/shared/utils/format-number';

import { ProfileImage } from '../../../../../shared/components/profile-image/profile-image';

interface ProfileCellProps {
  profileImageUrl: string;
  username: string;
  followerCount: number;
  onClick?: (event: React.MouseEvent) => void;
  className?: string;
  platform: SOURCE_PLATFORM_TYPE;
}

export function ProfileCell({
  profileImageUrl,
  username,
  followerCount,
  onClick,
  className,
  platform,
}: ProfileCellProps) {
  return (
    <AnimatedSuspense
      fallback={() => <div className={cn('text-sm text-gray-500', className)}>Error occured</div>}
    >
      <div className={cn('group flex items-center gap-2.5', className)} onClick={onClick}>
        <ProfileImage
          src={profileImageUrl}
          name={username}
          className="size-10 rounded-full object-cover text-sm"
        />
        <div className="flex min-w-0 flex-col">
          <div className="flex items-center gap-1">
            <span className="text-foreground truncate text-sm leading-5 font-medium group-hover:underline">
              {username}
            </span>
            <PlatformLogo platform={platform} />
          </div>
          <div className="text-muted-foreground truncate text-sm leading-5 font-normal group-hover:underline">
            {formatNumber(followerCount)}
          </div>
        </div>
      </div>
    </AnimatedSuspense>
  );
}

const PlatformLogo = ({ platform }: { platform: SOURCE_PLATFORM_TYPE }) => {
  const Logo = PLATFORM_LOGO_BY_TYPE[platform];
  return <Logo className="size-4" />;
};
